module.exports = __webpack_public_path__ + "static/media/jump_rope_img.3dbf1d24.png";